import { render, staticRenderFns } from "./PendenciaModal.vue?vue&type=template&id=05cb76c6&scoped=true"
import script from "./PendenciaModal.vue?vue&type=script&lang=js"
export * from "./PendenciaModal.vue?vue&type=script&lang=js"
import style0 from "./PendenciaModal.vue?vue&type=style&index=0&id=05cb76c6&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05cb76c6",
  null
  
)

export default component.exports